export const matchesFilter = (currency, filters, curInfo) => {
  if (!curInfo || !curInfo[currency]) return false;

  const currencyData = curInfo[currency];
  const currentPrice = currencyData.price;

  if (!currentPrice) return false;

  return Object.entries(filters).every(([filterKey, { tf, op, value }]) => {
    if (!tf || !op || value === "") return true;

    let percentageDifference;

    if (filterKey === "ma" || filterKey === "bb") {
      const indicatorValue =
        filterKey === "ma"
          ? currencyData.ma?.[tf]
          : op === ">"
          ? currencyData.bb?.[tf]?.upper
          : currencyData.bb?.[tf]?.lower;

      if (indicatorValue === undefined) return false;

      percentageDifference = ((currentPrice - indicatorValue) / indicatorValue) * 100;

      return op === ">" ? percentageDifference > value : percentageDifference < value;
    }

    const filterValue = currencyData[filterKey]?.[tf];
    if (filterValue === undefined) return false;

    return op === ">" ? filterValue > value : filterValue < value;
  });
};

export const defaultFilters = () => {
  return {
    cryptoOnly: false,
    aiValidatedOnly: false,
    referenceOnly: false,
    tf: [],
    ma: { tf: "", op: "", value: "" },
    bb: { tf: "", op: "", value: "" },
    rsi: { tf: "", op: "", value: "" },
    sec: {  op: ">=", value: "" },
    currencies: []
  };
}

export const matchesGlobalEventFilters = (event, filters = {}) => {
  if (filters.cryptoOnly && String(event?.assetType || "").toUpperCase() === "STOCK") {
    return false;
  }

  if (filters.aiValidatedOnly && event?.codexEvaluation == null) {
    return false;
  }

  if (filters.referenceOnly && event?.codexEvaluation?.responseMode !== "REFERENCE_V1") {
    return false;
  }

  return true;
}

export const isDefaultFilters = (fil) => {
  return JSON.stringify(fil) === JSON.stringify(defaultFilters());
}
  
const getPercentageDiff = (price, indVal) => {
  return ((price - indVal) / indVal) * 100;

}
  
export const filterEvents = (events = [], filters = {}, curInfo = {}, currencies = []) => {

  return events.filter((event) => {
    if (!matchesGlobalEventFilters(event, filters)) {
      return false;
    }

    const eCandle = String(event?.tf || "").replace("_", "");

    const filtered = (!filters || !filters.tf || filters.tf.length === 0)
        || filters.tf.includes(eCandle);

    if (!filtered) {
      return false;
    }

    if (currencies && currencies.length > 0) {
      if (currencies.indexOf(event.cur) === -1) {
        return false;
      }
    }

    if (filters.bb && filters.bb.op && filters.bb.value) {

      const bollingerFrame = curInfo[event.cur] ? curInfo[event.cur].bb[eCandle] : null;

      if (bollingerFrame) {
        const indValue = filters.bb.op === ">" ? bollingerFrame.upper : bollingerFrame.lower;
        if (!eval(getPercentageDiff(curInfo[event.cur].price, indValue) + filters.bb.op + filters.bb.value)) {
          return false;
        }
      } else {
        return false;
      }
    }

    if (filters.ma && filters.ma.op && filters.ma.value) {

      const maFrameValue = curInfo[event.cur] ? curInfo[event.cur].ma[eCandle] : null;

      if (maFrameValue) {
        if (!eval(getPercentageDiff(curInfo[event.cur].price, maFrameValue) + filters.ma.op + filters.ma.value)) {
          return false;
        }
      } else {
        return false;
      }
    }

    if (filters.rsi && filters.rsi.op && filters.rsi.value) {

      const rsiFrameValue = curInfo[event.cur] ? curInfo[event.cur].rsi[eCandle] : null;

      if (rsiFrameValue) {
        if (!eval(rsiFrameValue + filters.rsi.op + filters.rsi.value)) {
          return false;
        }
      } else {
        return false;
      }
    }

    if (filters.sec && filters.sec.op && filters.sec.value) {
      return curInfo[event.cur] ? eval(curInfo[event.cur].appearances +  filters.sec.op + filters.sec.value) : false;
    }

    return true;
  });
};
